module.exports = __webpack_public_path__ + "static/media/timer-thinking.29184d03.png";